import ModuleSkeleton from "@/components/app/ModuleSkeleton";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Video, Phone, Monitor, Calendar, Users, Mic, Sparkles, Link as LinkIcon } from "lucide-react";

export default function MeetingsVideo() {
  return (
    <ModuleSkeleton
      testid="meetings-video-page"
      title="Meetings & Video"
      subtitle="Built-in HD video meetings, screen-share, and AI-summarised notes — without leaving QrewHR."
      icon={Video}
      badge="Basic Version"
      tagline="Native video calling for every employee"
      features={[
        { title: "HD Video & Screen Share", description: "WebRTC-powered low-latency calls with adaptive bitrate.", icon: Monitor },
        { title: "AI Meeting Summary",      description: "Claude 4.5 transcribes, summarises, and assigns action items.", icon: Sparkles },
        { title: "Calendar-aware Joins",    description: "1-click join from Calendar, Inbox, and meeting reminders.", icon: Calendar },
      ]}
      capabilities={[
        "Up to 100 participants per meeting (Enterprise)",
        "Meeting recording → auto-stored to Documents",
        "Background blur + virtual backgrounds",
        "Live captions in 30+ languages",
        "Breakout rooms for workshops & all-hands",
        "Phone dial-in (Twilio integration)",
      ]}
      cta={{ label: "Notify me when live", onClick: () => {} }}
    >
      <Card className="p-6 border border-slate-200" data-testid="meetings-video-preview">
        <div className="text-xs uppercase tracking-[0.18em] font-bold text-slate-500 mb-4">Preview — Today's call schedule</div>
        <div className="space-y-3">
          {[
            { time: "10:00", title: "Engineering standup",   participants: 8, type: "Team" },
            { time: "14:30", title: "1:1 with Priya Sharma", participants: 2, type: "1:1"  },
            { time: "16:00", title: "Quarterly all-hands",   participants: 47, type: "All-hands" },
          ].map((m) => (
            <div key={m.title} className="flex items-center gap-4 p-3 rounded-xl bg-slate-50 border border-slate-200">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-violet-500 to-indigo-500 text-white flex items-center justify-center">
                <Video className="w-5 h-5" />
              </div>
              <div className="flex-1">
                <div className="font-semibold text-slate-900 text-sm">{m.title}</div>
                <div className="text-xs text-slate-500 mt-0.5 inline-flex items-center gap-3">
                  <span>{m.time}</span> · <span className="inline-flex items-center gap-1"><Users className="w-3 h-3" /> {m.participants}</span> · <span>{m.type}</span>
                </div>
              </div>
              <Button variant="outline" size="sm" className="text-xs">
                <LinkIcon className="w-3 h-3 mr-1" /> Copy link
              </Button>
              <Button size="sm" className="text-xs bg-emerald-500 hover:bg-emerald-600 text-white">
                <Phone className="w-3 h-3 mr-1" /> Join
              </Button>
            </div>
          ))}
        </div>
        <div className="mt-4 text-[11px] text-slate-400 text-center">
          Native calling launches Q3 2026. Until then, paste your Zoom/Meet link in the regular Meetings page.
        </div>
      </Card>
    </ModuleSkeleton>
  );
}
